"use client";

import Card from "~/components/cards/Card";
import Flex from "~/components/flex/Flex";
import MobileNavPopup from "~/components/modal/MobileNavPopop";
import RightSideModal from "~/components/modal/RightSideModal";
import Text from "~/components/texts/Text";
import { Icon, IconName } from "~/components/icons/Icon";
import { spacing } from "~/utils/tailwindUtils";

type ResponsiveModalProps = {
  title: string | React.ReactNode;
  isOpen: boolean;
  onRequestClose: () => void;
  children: React.ReactNode;
  cardClassName?: string;
  childrenDivWrapperClassName?: string;
  animationDuration?: number;
};

/**
 * A responsive modal component that shows:
 * - MobileNavPopup for mobile devices (< md)
 * - RightSideModal for desktop (≥ md)
 */
const ResponsiveModal = ({
  title,
  cardClassName,
  isOpen,
  onRequestClose,
  children,
  childrenDivWrapperClassName,
  animationDuration = 750,
}: ResponsiveModalProps) => {
  return (
    <>
      <Card className="fixed bottom-0 left-0 w-screen rounded-b-none p-0 md:hidden gap-2 bg-transparent border-none z-90">
        <MobileNavPopup showMobileNavPopover={isOpen} handleSwitchMobileNavPopover={onRequestClose}>
          <Flex className="flex-col gap-2 px-4 py-6">
            <Flex className="justify-between gap-4">
              <Text className="text-sm md:text-lg font-bold">{title}</Text>
              <Flex className="rounded-full hover:bg-gray-50 cursor-pointer" onClick={onRequestClose}>
                <Icon name={IconName.Cancel} size={spacing[4]} customStrokeWidth={2} colorMode="fill" />
              </Flex>
            </Flex>
            {children}
          </Flex>
        </MobileNavPopup>
      </Card>

      <div className="hidden md:block">
        <RightSideModal
          header={title}
          isOpen={isOpen && typeof window !== "undefined" ? window.innerWidth >= 768 : isOpen} // check if the window is mobile
          onRequestClose={onRequestClose}
          outsideClick
          cardClassName={cardClassName}
          childrenDivWrapperClassName={childrenDivWrapperClassName}
          animationDuration={animationDuration}
        >
          {children}
        </RightSideModal>
      </div>
    </>
  );
};

export default ResponsiveModal;
